import emUtils from "@/utils/emUtils";

export function customVuexFilterPatternFactory({
                                                   store: {state, actions, mutations}
                                                   , param: {
        filterState = "emCustomQueryFilter",
        filterInitializer = () => {
            return {}
        }
    }
                                               } = {}) {
    //添加state
    Object.assign(state, {[filterState]: Object.assign({}, filterInitializer()),[`${filterState}Holder`]:{}})
    //转换首字母大写
    let filterState_cap_first = emUtils.toCapFirst(filterState)
    //添加mutations
    Object.assign(mutations, {
        //设置loadState
        [`set${filterState_cap_first}`](state, data) {
            state[filterState] = data
        },
        //设置filterStateAttribute
        [`set${filterState_cap_first}Attribute`](state, parameters) {
            state[filterState][parameters.key] = parameters.newValue;
        },
        // 清空filterState，不保留filterHolder
        [`setClear${filterState_cap_first}WithoutHolder`](state) {
            state[filterState] = Object.assign({}, filterInitializer())
        },
        // 清空filterState，默认会保留filterHolder
        [`setClear${filterState_cap_first}`](state) {
            // state[filterState] = Object.assign({}, filterInitializer())
            state[filterState] = JSON.parse(JSON.stringify(Object.assign(filterInitializer(), state[`${filterState}Holder`])))
        },
        [`set${filterState_cap_first}Holder`](state,filterHolder) {
            state[`${filterState}Holder`] = filterHolder
        }
    })
}